import { c as _c } from "react/compiler-runtime";
import type { NgProps } from "./types";
export const makeNg = <T,>(Ng?: React.FC<NgProps<T>>) => {
  // Alias
  const NgWrap: React.FC<NgProps<T>> = props => {
    const $ = _c(4);
    let t0;
    if ($[0] !== props) {
      t0 = Ng != null && <Ng {...props} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    let t1;
    if ($[2] !== t0) {
      t1 = <>{t0}</>;
      $[2] = t0;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  };
  return NgWrap;
};